const VENDORS_API_PATH = '/api/v1/vendors';

async function saveVendor(vendor, onSuccess, onError) {
  const formData = new FormData();
  formData.append('vendorValidationToken', vendor.token);
  formData.append('vendorName', vendor.name);
  formData.append('vendorEmail', vendor.email);
  formData.append('vendorNpwp', vendor.npwp);
  formData.append('vendorAddress', vendor.address);
  if (vendor.npwpFile) {
    formData.append('npwpFile', vendor.npwpFile);
  }
  formData.append('opBuyerCompanyId', vendor.opBuyerCompanyId);

  const response = await fetch(VENDORS_API_PATH, {
    method: 'POST',
    body: formData
  });

  if (response.ok) {
    onSuccess();
  } else {
    onError();
  }
}

export {
  VENDORS_API_PATH,
  saveVendor
};
